import React from "react";
import * as actions from './actions';
export default function ReligionPopup({ eleRef }){
    const items = [];
    for (const [index, value] of eleRef.entries()) {
        items.push(
            <li key={index} onClick={actions.checkfiltersubcat.bind(this)} >
                <span className="icon check" data-icon-font="z"></span>
                <span className="R14_42 genName">{value.key}</span>
            </li>);
    }
    return(
       <div className="religion_popup_overlay overlay">
            <div className="religion_popup filter_popups">
                <span className="M18_42">Please Select religion</span>
                <ul>
                    {items}
                </ul>
                <div className="action_buttons right">
                    <span className="M14_9e cancelfilterbtn" onClick={(e) => actions.cancelpopup(e)}>CANCEL</span>
                    <span className="applyfilterbtn M14_pink" onClick={(e) => actions.applypopup(e)}>APPLY</span>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/baby-names/ReligionPopup.js